import { useCallback } from 'react';
import { useGenericModal } from '..';
import { CsvUploadModal, CsvUploadModalProps } from './csv-upload-modal';

export const useCsvUploadModal = (props: Partial<CsvUploadModalProps>) => {
  const { modalRef, openModal, closeModal } = useGenericModal();

  const onClose = useCallback(() => {
    closeModal();
    props.onClose?.();
  }, [closeModal, props]);

  const CsvUploadModalComponent = (
    <CsvUploadModal {...props} modalRef={modalRef} onClose={onClose} />
  );

  return {
    modalRef,
    openModal,
    closeModal,
    modal: CsvUploadModalComponent,
  };
};
